import { useHelmet } from '@agro-club/agroclub-shared'

import { useTranslation } from 'react-i18next'

import * as Layout from 'views/layouts/NewLayout'
import * as Header from 'views/ui/Header/Header'
import { FC, useState } from 'react'
import APageWrapper from 'views/components/PageWrapper/APageWrapper'
import { SellerPotentialFilters } from './SellerPotentialFilters'
import { useFilters } from 'hooks/useFilter'
import { ListRequestParams } from 'modules/domain/types'
import { defaultListRequestParams } from 'views/components/TableFilters/data'
import ATableFullPage from 'views/components/Table/ATableFullPage'
import { endpoints } from 'modules/endpoints'
import { useColumns } from './useColumns'
import { useSingleEntity } from 'modules/domain/common/hooks'
import { stringify } from 'query-string'
import { SumType } from './types'
import { StatsComponent } from './StatsComponent'

export const SellerPotentialAnalytics: FC = () => {
  const { t } = useTranslation('user')
  useHelmet({ title: t('sellerPotentialAnalytics') })
  const [listRequestParams, setListRequestParams] = useState<ListRequestParams>({
    ...defaultListRequestParams,
  })

  const { isFiltersLoaded, updateFilterState } = useFilters({
    listRequestParams,
    setListRequestParams,
  })
  const [, sumData] = useSingleEntity<SumType>(
    `${endpoints.productDataAnalyticsSum()}?${stringify(listRequestParams.filter)}`,
    false,
  )
  const columns = useColumns(sumData)

  return (
    <APageWrapper page="sellerPotential" place="sellerPotential">
      <Layout.WrapperContent>
        <Layout.Header>
          <Layout.TopHeader>
            <Header.Breadcrumbs
              routes={[
                {
                  breadcrumbName: t('sellerPotentialAnalytics'),
                },
              ]}
            />
          </Layout.TopHeader>

          <Layout.PageName>{t('sellerPotentialAnalytics')}</Layout.PageName>
          <SellerPotentialFilters
            setListRequestParams={setListRequestParams}
            updateFilterState={updateFilterState}
            listRequestParams={listRequestParams}
            isFiltersLoaded={isFiltersLoaded}
          />
          <StatsComponent listRequestParams={listRequestParams} />
        </Layout.Header>

        <ATableFullPage
          listParamsUpdated={setListRequestParams}
          listRequestParams={listRequestParams}
          isFiltersLoaded={isFiltersLoaded}
          dataEndpoint={endpoints.productDataAnalytics()}
          columns={columns}
          rowHoverGray
        />
      </Layout.WrapperContent>
    </APageWrapper>
  )
}
